<template>
  <div class="sms-settings">
    <vtitle />

    <div class="sms-settings__header">
      {{ $tr('vacancy.preferences.sms.inviteTemplates') }}
    </div>

    <sms-list
      v-if="inviteTemplatesOpened"
      v-model="templatesInvite"
      can-disabled
      checkboxpl="vacancy.preferences.sms.interview"
      :change-item="changeOneInviteSms"
      :render-template="renderInvite"
    />

    <div class="sms-settings__header">
      {{ $tr('vacancy.preferences.sms.remindTemplate') }}
    </div>

    <sms-list
      v-if="remindTemplateOpened"
      v-model="templatesRemind"
      can-disabled
      checkboxpl="vacancy.preferences.sms.enable"
      :change-item="changeOneRemindSms"
      :render-template="renderRemind"
    />

    <vbutton label="common.save" :disabled="max_chars_exceeded || isValueEmpty" @click="save" />
  </div>
</template>

<script>
import { check_hidden_country } from '@/_helpers/utils';
import SmsList from '@/routes_new/inner/vacancy/sms/components/SmsList';
import vtitle from '@/routes_new/inner/vacancy/components/vtitle';

export default {
  name: 'VacancySms',

  components: {
    SmsList,
    vtitle
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      const vacancy = vm.$store.getters['vacancy/one'];
      const is_hidden_country = vacancy && vacancy.country && check_hidden_country(vacancy.country.code);

      if (!is_hidden_country) {
        next();
      } else {
        vm.$nextTick(() => {
          next({ name: 'vacancy_basic' });
        });
      }
    });
  },

  props: {
    vacancyId: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      inviteTemplatesOpened: true,
      remindTemplateOpened: true
    };
  },

  computed: {
    templatesRemind() {
      return this.$store.getters['vacancy/sms/templatesRemind'];
    },

    templatesInvite() {
      return this.$store.getters['vacancy/sms/templatesInvite'];
    },

    renderRemind() {
      return this.$store.getters['vacancy/sms/renderRemind'].template;
    },

    renderInvite() {
      return this.$store.getters['vacancy/sms/renderInvite'].template;
    },

    max_chars_exceeded() {
      return this.$store.getters['vacancy/sms/max_chars_exceeded'];
    },

    isValueEmpty() {
      let isTemplatesInviteEmpty = false;
      let isTemplatesRemindEmpty = false;

      if (this.templatesInvite && this.templatesInvite.length) {
        this.templatesInvite.forEach(item => {
          if (item && !item.template) {
            isTemplatesInviteEmpty = true;
          }
        });
      }

      if (this.templatesRemind && this.templatesRemind.length) {
        this.templatesRemind.forEach(item => {
          if (item && !item.template) {
            isTemplatesRemindEmpty = true;
          }
        });
      }

      return isTemplatesInviteEmpty || isTemplatesRemindEmpty;
    }
  },

  async created() {
    await this.fetchTemplatesRemind();
    await this.fetchTemplatesInvite();
  },

  beforeDestroy() {
    this.clear_sms_templates();
  },

  methods: {
    changeOneInviteSms(item) {
      let obj = this.templatesInvite.filter(i => i.id === item.id)[0];
      delete item.id;
      const changedItem = Object.assign({}, obj, item);
      this.$store.dispatch('vacancy/sms/changeOneInviteSms', changedItem);
    },

    changeOneRemindSms(item) {
      let obj = this.templatesRemind.filter(i => i.id === item.id)[0];
      delete item.id;
      const changedItem = Object.assign({}, obj, item);
      this.$store.dispatch('vacancy/sms/changeOneRemindSms', changedItem);
    },

    fetchTemplatesRemind() {
      this.$store
        .dispatch('vacancy/sms/fetchSmsRemind', { vacancyId: this.vacancyId })
        .then(() => this.renderTemplatesRemind());
    },

    fetchTemplatesInvite() {
      this.$store
        .dispatch('vacancy/sms/fetchSmsInvite', {
          vacancyId: this.vacancyId
        })
        .then(() => this.renderTemplatesInvite());
    },

    updateTemplatesRemind() {
      return this.$store.dispatch('vacancy/sms/updateSmsRemind', {
        vacancyId: this.vacancyId,
        templates: this.templatesRemind
      });
    },

    updateTemplatesInvite() {
      return this.$store.dispatch('vacancy/sms/updateSmsInvite', {
        vacancyId: this.vacancyId,
        templates: this.templatesInvite
      });
    },

    renderTemplatesRemind() {
      return this.$store.dispatch('vacancy/sms/renderSmsRemind', {
        vacancyId: this.vacancyId,
        templates: this.templatesRemind
      });
    },

    renderTemplatesInvite() {
      return this.$store.dispatch('vacancy/sms/renderSmsInvite', {
        vacancyId: this.vacancyId,
        templates: this.templatesInvite
      });
    },

    save() {
      if (this.templatesRemind.some(t => !t.template) || this.templatesInvite.some(t => !t.template)) {
        this.$noty.error('Empty templates are not allowed'); // Перевод нужен, его тут как бы и не было
      } else {
        Promise.all([
          this.updateTemplatesRemind(),
          this.updateTemplatesInvite(),
          this.renderTemplatesRemind(),
          this.renderTemplatesInvite()
        ])
          .then(() => {
            this.$noty.success(this.$tr('vacancy.preferences.modals.saveSuccess.text')); // уточнить текст для сохранения sms
          })
          .catch(() => {
            this.$noty.error(this.$tr('vacancy.preferences.modals.saveFailure.text')); // уточнить текст для ошибки сохранения sms
          });
      }
    },

    clear_sms_templates() {
      this.$store.commit('vacancy/sms/clear');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.sms-settings {
  max-width: 600px;

  &__header {
    @include mixin-text-header;
    margin: 0 0 14px;
  }
}
</style>
